import React, { Component } from 'react';
import { ProgressBar } from 'react-bootstrap';
import axios from 'axios';
import carImage from '../../public/agsm/car.png';

require(`../assets/${process.env.PAGE}/css/components/flow-progress-bar.css`);

class FlowProgressBar extends Component {
    constructor(props) {
        super(props);
        this.state = { progress: null };
    }

    componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };
        axios.get(`${ROOT_URL}/leads/steps/current_step`, config)
            .then((response) => {
                let progress = (response.data.current_step / response.data.total_steps) * 100;
                if (progress > 100) progress = 100;
                progress = Math.floor(progress);
                this.setState({ progress });
            });
    }

    render() {
        const { progress } = this.state;

        const progressBar = (
            <div className="row">
                <div
                    className="col-lg-4 col-md-4 col-sm-10 col-xs-10 col-lg-offset-4 col-md-offset-4 col-sm-offset-1 col-xs-offset-1 text-center progress-custom "
                    style={{ position: 'relative' }}
                >
                    <ProgressBar
                        className={'flow-progress-bar custom-progress-bar'}
                        now={progress}
                        max={100}
                        min={0}
                    />
                    <div
                        className="progress-label"
                        style={{ left: `calc(${progress}% - 14px)` }}
                    >
                        <img src={carImage} alt="car" className="car-icon" />
                    </div>
                    <div className="progress-text">{`${progress}%`}</div>
                </div>
            </div>
        );

        return progress !== null ? progressBar : (<div style={{ marginTop: "40px" }}></div>);
    }
}

export default FlowProgressBar;



/** WEBPACK FOOTER **
 ** ./src/components/FlowProgressBar.js
 **/